import { ApolloClient, InMemoryCache, ApolloLink, concat, from } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { createUploadLink } from 'apollo-upload-client';
import { store } from './redux/store';
import { clearUser } from './redux/authSlice';

const uploadLink = createUploadLink({
  uri: process.env.REACT_APP_GRAPHQL_END_POINT || "https://staging.vmt4td.carriagereturn.net/graphql",
});

const authMiddleware = new ApolloLink((operation, forward) => {
  const state = store.getState();
  operation.setContext({
    headers: {
      authorization: state.auth.accessToken ? `Bearer ${state.auth.accessToken}` : '',
      'X-Page-URL': window.location.href,
    }
  });
  return forward(operation);
});

const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path, extensions }) => {
      console.error(`GraphQL error: Message: ${message}, Location: ${locations}, Path: ${path}`);
      
      if (extensions?.code === 'UNAUTHENTICATED' || 
          message.toLowerCase().includes('unauthorized') ||
          message.toLowerCase().includes('unauthenticated')) {
        console.log('Authentication error detected, logging out user');
        
        sessionStorage.setItem('isAuthenticated', 'false');
        
        store.dispatch(clearUser());
        
        window.location.href = '/login';
      }
    });
  }

  if (networkError) {
    // console.error(`Network error: ${networkError}`);
    
    // if ('statusCode' in networkError && (networkError.statusCode === 401 || networkError.statusCode === 403)) {
    //   console.log('Network authentication error detected, logging out user');
      
      sessionStorage.setItem('isAuthenticated', 'false');
      
      store.dispatch(clearUser());
      
      window.location.href = '/login';
    // }
  }
});

const client = new ApolloClient({
  link: from([errorLink, authMiddleware, uploadLink as ApolloLink]),
  cache: new InMemoryCache()
});

export default client;
